module.exports = __webpack_public_path__ + "img/image1.60e14f22.svg";